const Portfolio = () => {
    return <>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae, maxime sint odit dolorem eum nostrum exercitationem quis commodi eos quam laboriosam nesciunt dignissimos officiis reiciendis quos excepturi est debitis quae!
        Nesciunt quae commodi qui aliquid dolore. Id consequatur doloribus itaque ad, beatae debitis soluta qui sapiente iste quis consequuntur eius dolores rem omnis optio aut earum! Dicta veniam iusto iure!
        Eum ab maxime repellendus aut assumenda, numquam placeat voluptates atque aspernatur? Hic quos natus a commodi. Voluptatem voluptas magni expedita eaque beatae enim est dolore odit sed, quod esse qui?
    </>
}

export default Portfolio;